import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Me } from './api.models';

/** Utilisateur connecté, rôle et sociétés accessibles (`GET /api/me`). */
@Injectable({ providedIn: 'root' })
export class MeService {
  private readonly http = inject(HttpClient);
  private readonly _me = signal<Me | null>(null);
  private loading: Promise<Me> | null = null;

  readonly me = this._me.asReadonly();
  readonly isAdmin = computed(() => this._me()?.isAdmin ?? false);
  readonly companies = computed(() => this._me()?.companies ?? []);

  load(): Promise<Me> {
    this.loading ??= firstValueFrom(this.http.get<Me>('/api/me')).then((me) => {
      this._me.set(me);
      return me;
    });
    return this.loading;
  }
}
